var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTrash = function SvgTrash(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.384 5.812a2.286 2.286 0 0 1 3.902 1.617H9.715c0-.607.24-1.188.669-1.617M8.572 7.43a3.429 3.429 0 1 1 6.857 0h3.428a.571.571 0 0 1 0 1.143h-1.143v9.714A1.714 1.714 0 0 1 16 20H8a1.714 1.714 0 0 1-1.714-1.714V8.572H5.143a.571.571 0 0 1 0-1.143zM7.429 8.572h9.143v9.714a.57.57 0 0 1-.572.571H8a.57.57 0 0 1-.571-.571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.286 9.714c.315 0 .571.256.571.572v6.285a.571.571 0 1 1-1.143 0v-6.285c0-.316.256-.572.572-.572m3.428 0c.316 0 .572.256.572.572v6.285a.572.572 0 0 1-1.143 0v-6.285c0-.316.256-.572.571-.572"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16v16H4z"
  })))));
};
export { SvgTrash as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.fde968f987565996168443a1b99a7370.svg";